import {configurationFile} from "../../config";
const hostname=window.location.hostname;
let environment=  hostname === 'panel.fapool.ir'? 'production':'development';

export const API_URL = configurationFile[environment].API_DOMAIN_NAME;
export const UPLOAD_URL = configurationFile[environment].UPLOAD_DOMAIN_NAME;
export const VENDOR_URL = configurationFile[environment].VENDOR_URL;
export const DefaultLang = "fa";
